import getter from '../getter';
export default function getEntityDefaultRecordCardComponent(entity) {
    const getterName = 'defaultRecordCardComponent';
    const result = getter(entity, getterName);
    return result;
}
